
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.031 20.04C9.467 13.314 14.458 8 20.561 8c3.112 0 6.027 1.39 8.18 3.816a1.072 1.072 0 01-.015 1.414.852.852 0 01-1.286-.017C25.625 11.167 23.176 10 20.561 10c-5.142 0-9.36 4.499-9.718 10.21L12.2 18.4a1 1 0 111.6 1.2l-2.999 4a1 1 0 01-1.6 0l-3-4A1 1 0 017.8 18.4l1.231 1.64zm25.938 3.92C34.533 30.685 29.542 36 23.441 36c-3.113 0-6.028-1.39-8.182-3.817a1.072 1.072 0 01.015-1.414.852.852 0 011.286.017C18.376 32.833 20.825 34 23.44 34c5.14 0 9.358-4.5 9.717-10.21L31.8 25.6a1 1 0 11-1.6-1.2l2.999-4a1 1 0 011.6 0l3 4a1 1 0 01-1.599 1.2l-1.231-1.64z"}})])
          )
        }
      }
    